import { AUTH_ACTIONS } from '../../../store/actions'
import { paths } from '../../../router/paths'
import { getDefaultRoute } from '../../../router'
import LeftSideNav from '../../layout/LeftSideNav.vue'
export default {
    components: {
        LeftSideNav
    },
    data() {
        return {
            isSidebarOpen: false,
            overlayVisible: false,
            userName: JSON.parse(localStorage.getItem('userD'))[0],
            crumbs: [],
            // Add window reference to make it reactive
            windowWidth: window.innerWidth,
        }
    },
    computed: {
        items() {
            const allItems = [
                {
                    to: paths.home.path,
                    text: 'Home',
                    icon: 'fas fa-home',
                    isAllowed: true
                },
                {
                    to: paths.gudid.path,
                    text: 'GUDID Devices List',
                    icon: 'fas fa-question-circle',
                    isAllowed: true
                },
                {
                    to: paths.extractedPaperRecalls.path,
                    text: 'Extracted Paper Recalls',
                    icon: 'fas fa-file-alt',
                    isAllowed: true
                },
                {
                    to: paths.llmComparison.path,
                    text: 'LLM Comparison',
                    icon: 'fas fa-brain',
                    isAllowed: true
                },
            ];
            // Filter out Home if current route is Home
            return allItems.filter(item => {
                if (item.text === 'Home' && this.$route.name === 'Home') {
                    return false;
                }
                return true;
            });
        }
    },
    created() {
        window.addEventListener('resize', this.screenResizeHandler)
    },

    destroyed() {
        window.removeEventListener('resize', this.screenResizeHandler)
    },

    mounted() {
        this.screenResizeHandler()
        // Add window resize listener
        window.addEventListener('resize', this.handleResize);
        this.handleResize(); // Initial check
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },

    watch: {
        isSidebarOpen(newValue) {
            // Handle mobile overlay visibility
            if (this.windowWidth <= 991) {
                this.overlayVisible = newValue;
            } else {
                this.overlayVisible = false;
            }
        }
    },

    methods: {
        overlayClick() {
            this.isSidebarOpen = false;
            this.overlayVisible = false;
        },
        sidebarToggle(type) {
            if (this.windowWidth < 992) {
                // Mobile behavior
                this.isSidebarOpen = !this.isSidebarOpen;
                this.overlayVisible = this.isSidebarOpen;
            } else {
                // Desktop behavior
                this.isSidebarOpen = !this.isSidebarOpen;
                this.overlayVisible = false;
            }
        },
        logout() {
            this.$store.dispatch(AUTH_ACTIONS.LOGOUT)

            this.$router.push({ name: 'Login' })
            localStorage.clear()
        },
        screenResizeHandler() {
            if (window.innerWidth <= 991) {
                this.isSidebarOpen = false
            } else {
                this.isSidebarOpen = true
            }
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
            // Auto-close sidebar on mobile when resizing
            if (this.windowWidth < 992) {
                this.isSidebarOpen = false;
            } else {
                this.isSidebarOpen = true;
                this.overlayVisible = false;
            }
        },
        hoverOn() {
            // Remove hover expand functionality for cleaner grid layout
        },
        hoverOff() {
            // Remove hover expand functionality for cleaner grid layout
        },
        openAccountMenu() {
            //debugger
            this.$refs.accountMenu.show()
            this.$refs.accountBtn.classList.add('show')
        },
        clickOutsideAccountMenu() {
            this.$refs.accountBtn.classList.remove('show')
        },
        openAccountMenuMobile() {
            this.$refs.accountMenuMobile.show()
        },
        goToOrganizationGeneralSetting() {
            this.$router.push({ name: 'Account' })
        },
        goToHome() {
            this.$router.push({ name: 'Home' })
        },
        _fetchAvatarVariant(user) {
            // Simple variant logic - you can customize this
            return 'primary'
        },
        _name2Digit(user) {
            // Extract initials from user data - you can customize this
            if (typeof user === 'string') {
                return user.substring(0, 2).toUpperCase()
            }
            return 'US'
        },
        openExternalLink(url) {
            window.open(url, '_blank')
        }
    }
}